// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dax6b","divider":"Footer_divider__3urBr","text":"Footer_text__2Yhdq","containerFooter":"Footer_containerFooter__2uwpI","link":"Footer_link__3m137"};